export const pages = [
    {
        nome: 'Lojas',
        url: '/lojas'
    },
    {
        nome: 'Categorias',
        url: '/categorias'
    },
    {
        nome: 'Ajuda',
        url: '/ajuda/perguntas-frequentes'
    },
    {
        nome: 'Para Empresas',
        url: '/clubes'
    }
]